import { render } from "./DelaMinnen.vue?vue&type=template&id=80e5af22&scoped=true"
import script from "./DelaMinnen.vue?vue&type=script&lang=js"
export * from "./DelaMinnen.vue?vue&type=script&lang=js"

import "./DelaMinnen.vue?vue&type=style&index=0&id=80e5af22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80e5af22"]])

export default __exports__